const SocialImpactScreen = () => {

    return(
        <p>Social impact</p>
    )
}

export default SocialImpactScreen